export default [
  {
    label: 'Item Name',
    display: 'Item Name',
    value: 'itemName',
    type: 'text',
  },
  {
    label: 'Purity',
    display: 'Purity',
    value: 'Purity',
    type: 'text',
  },
  {
    label: 'Size',
    display: 'Size',
    value: 'size',
    type: 'text',
  },
  {
    label: 'PurityInPercent',
    display: 'PurityInPercent',
    value: 'purity',
    type: 'info',
  },
  {
    label: 'Barcode',
    display: 'Barcode',
    value: 'itemCode',
    type: 'text',
  },
  {
    label: 'M. Ch',
    display: 'Making Charge',
    value: 'makingCharge',
    type: 'info',
  },
  {
    label: 'S. M. Ch',
    display: 'sMaking Charge',
    value: 'sMakingCharge',
    type: 'info',
  },
  {
    label: 'M. Ct',
    display: 'Making Charge Type',
    value: 'makingChargeType',
    type: 'text',
  },
  {
    label: 'S. M. Ct',
    display: 'sMaking Charge Type',
    value: 'sMakingChargeType',
    type: 'text',
  },
  {
    label: 'M. Am',
    display: 'Making Amount',
    value: 'makingAmount',
    type: 'info',
  },
  {
    label: 'S. M. Am',
    display: 'sMaking Amount',
    value: 'sMakingAmount',
    type: 'info',
  },
  {
    label: 'W. Ty',
    display: 'Wastage Type',
    value: 'wastageType',
    type: 'text',
  },
  {
    label: 'S. W. Ty',
    display: 'sWastage Type',
    value: 'sWastageType',
    type: 'text',
  },
  {
    label: 'W. Wt',
    display: 'Wastage Weight',
    value: 'wastageWeight',
    type: 'info',
  },
  {
    label: 'S. W. Wt',
    display: 'sWastage Weight',
    value: 'sWastageWeight',
    type: 'info',
  },
  {
    label: 'G. Wt',
    display: 'Gross Weight',
    value: 'grossWeight',
    type: 'info',
  },
  {
    label: 'R',
    display: 'Rate',
    value: 'rate',
    type: 'info',
  },
  {
    label: 'W. Ch',
    display: 'Wastage Charge',
    value: 'wastageCharge',
    type: 'info',
  },
  {
    label: 'S. W. Ch',
    display: 'sWastage Charge',
    value: 'sWastageCharge',
    type: 'info',
  },
  {
    label: 'S. Pc',
    display: 'Set Pcs',
    value: 'setPcs',
    type: 'info',
  },
  {
    label: 'E. Am',
    display: 'Extra Amount',
    value: 'extraAmount',
    type: 'info',
  },
  {
    label: 'S. E. Am',
    display: 'sExtra Amount',
    value: 'sExtraAmount',
    type: 'info',
  },
  {
    label: 'S. Wt',
    display: 'Stone Weight',
    value: 'stoneWeight',
    type: 'info',
  },
  {
    label: 'D. Wt',
    display: 'Diamond Weight',
    value: 'diamondWeight',
    type: 'info',
  },
  {
    label: 'N. Wt',
    display: 'Net Weight',
    value: 'netWeight',
    type: 'info',
  },
  {
    label: 'Se. N. Wt',
    display: 'Secondary Net Weight',
    value: 'netWeightSc',
    type: 'info',
  },
  {
    label: 'F. Am',
    display: 'Fixed Amount',
    value: 'sFixedAmount',
    type: 'info',
  },
  {
    label: 'N. Am',
    display: 'Net Amount',
    value: 'netAmount',
    type: 'info',
  },
  {
    label: 'S. N. Am',
    display: 'sNet Amount',
    value: 'sNetAmount',
    type: 'info',
  },
  {
    label: 'S. Am',
    display: 'Stone Amount',
    value: 'totalSalesStoneAmount',
    type: 'text',
  },
  {
    label: 'D. Am',
    display: 'Diamond Amount',
    value: 'totalSalesDiamondAmount',
    type: 'text',
  },
  {
    label: 'S. Pcs',
    display: 'Stone Pieces',
    value: 'stonePcs',
    type: 'info',
  },
  {
    label: 'D. Pcs',
    display: 'Diamond Pieces',
    value: 'diamondPcs',
    type: 'info',
  },
  {
    label: 'N. Wa',
    display: 'Net With Wastage',
    value: 'netWithWastage',
    type: 'info',
  },
  {
    label: 'P. Wt',
    display: 'Pure Weight',
    value: 'pureWeight',
    type: 'info',
  },
  {
    label: 'D. Info',
    display: 'Detailed Diamond Info',
    value: 'Diamond-key-item',
    type: 'info',
    keys: [
      'itemName',
      'rateOn',
      'pcs',
      'unit',
      'weight',
      'rate',
      'salesAmount',
      'hc',
      'color',
      'clarity',
      'cut',
    ],
  },
  {
    label: 'S. Info',
    display: 'Detailed Stone Info',
    value: 'Stone-key-item',
    type: 'info',
    keys: [
      'itemName',
      'rateOn',
      'pcs',
      'unit',
      'weight',
      'rate',
      'salesAmount',
      'hc',
      'color',
      'clarity',
      'cut',
    ],
  },
  {
    label: 'printQty',
    display: 'Print Quantity',
    value: 'printQty',
    type: 'text',
  },
  {
    label: 'itemGroup',
    display: 'Item Group',
    value: 'itemGroup',
    type: 'text',
  },

  // {
  //   label: 'groupName',
  //   display: 'Group Name',
  //   value: 'groupName',
  //   type: 'text',
  // },

  {
    label: 'categoryName',
    display: 'Category Name',
    value: 'categoryName',
    type: 'text',
  },
  {
    label: 'generalRemarks',
    display: 'General Remarks',
    value: 'generalRemarks',
    type: 'text',
  },
  {
    label: 'Remarks',
    display: 'Remarks',
    value: 'remarks',
    type: 'text',
  },
  {
    label: 'description',
    display: 'Item Description',
    value: 'description',
    type: 'text',
  },
  {
    label: 'karigarName',
    display: 'Karigar Name',
    value: 'karigarName',
    type: 'text',
  },
  {
    label: 'wtInTola',
    display: 'Weight In Tola',
    value: 'wtInTola',
    type: 'info',
  },
  {
    label: 'metalAmount',
    display: 'Metal Amount',
    value: 'metalAmount',
    type: 'info',
  },
];
